// extracted by mini-css-extract-plugin
export default {"tagsWrap":"SelectAddMulti_tagsWrap__NxiQ8","tag":"SelectAddMulti_tag__BodTI"};